export enum RequestType {
  FOLLOW_USER = 'FOLLOW_USER',
  JOIN_GROUP = 'JOIN_GROUP',
  JOIN_PLAN = 'JOIN_PLAN',
}

export enum RequestStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  UNDETERMINED = 'UNDETERMINED',
}

export type Request = {
  requestId: string;
  userId: string;
  entityId: string;
  type: RequestType;
  status: RequestStatus;
  createdAt: Date;
  updatedAt: Date;
};

export enum RequestOp {
  ADD = 'ADD',
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
  DELETE = 'DELETE',
}

export type RequestCall = Pick<Request, 'userId' | 'entityId' | 'type'> & { op: RequestOp };
export type RequestReturn = RequestStatus | void;

export type AddRequestHandler = (input: {
  authUserId: string;
  request: Omit<RequestCall, 'op'>;
}) => Promise<RequestStatus | void>;

export type AcceptRequestHandler = (input: {
  authUserId: string;
  request: Request;
}) => Promise<void>;

export type RejectRequestHandler = (input: {
  authUserId: string;
  request: Request;
}) => Promise<void>;

export type DeleteRequestHandler = (input: {
  authUserId: string;
  request: Request;
}) => Promise<void>;
